export default "__VITE_ASSET__Bo9T2oI1__"